<template>
	<div id="contact">
		<div class="pageTitle">
			<h1 class="title">CONTACT</h1>
		</div>

		<div class="contactBox">
			<div class="contactForm">
				<transition name="slide">
					<div 	class="msgStatus"
							:class="{
								success: msgStatus.valid,
								error: !msgStatus.valid
							}"
							v-if="msgStatus.valid !== null">
						<h1>{{ msgStatus.msg }}</h1>
					</div>
				</transition>

				<form>
					<div class="inputShadow">
						<input type="text" v-model="fromEmail" placeholder="Enter your email"><br>
						<input type="text" v-model="fromName" placeholder="Enter your name"><br>
						<textarea type="text" v-model="body" placeholder="Enter your message"></textarea><br>
					</div>
					<div class="formButtons">
						<button type="button" @click="submitMsg">Submit</button>
						<button type="button" @click="clearMsg">Clear</button>
					</div>
				</form>
			</div>

			<div class="socialIcons">
	            <a target="_blank" rel="noopener" href="mailto:emilyqualmann@gmail.com">
	                <i class="fa fa-envelope fa-2x" aria-hidden="true"></i>
	            </a>

	            <a target="_blank" rel="noopener" href="https://www.instagram.com/emilyqualmann/">
	                <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
	            </a>				

	            <a target="_blank" rel="noopener" href="https://soundcloud.com/user-807035398">
	                <i class="fa fa-soundcloud fa-2x" aria-hidden="true"></i>
	            </a>				

	            <a target="_blank" rel="noopener" href="https://www.youtube.com/channel/UC1mbMp1chMSffdOMYNgrsCg">
	                <i class="fa fa-youtube-play fa-2x" aria-hidden="true"></i>
	            </a>
			</div>	
		</div>
	</div>
</template>

<script>
import axios from 'axios';

export default{
	name:"Contact",
	data(){
		return {
			fromEmail: 'Email',
			fromName: 'Name',
			body: 'Message',
			msgStatus: {
				msg: null,
				valid: null
			},
			reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/
		}
	},
	methods: {
		submitMsg: function(){
			if(this.fromEmail == null || this.fromEmail == ''){
				this.msgStatus = {
					msg: 'Please Enter Email',
					valid: false
				}
				return;
			}
			else if(!this.reg.test(this.fromEmail)){
				this.msgStatus = {
					msg: 'Please Enter Correctly Formatted Email',
					valid: false
				}
				return;
			}
			let data = {
				author_name: this.fromName,
				author_email: this.fromEmail,
				content: this.body,
				post: 272,
				date: new Date()
			};

			axios.post(process.env.VUE_APP_WP_URL+"/wp-json/wp/v2/comments",data)
			.then(response => {
				this.msgStatus = {
					msg: 'Sent',
					valid: true
				}
				setTimeout(() => { this.msgStatus.valid = null; }, 3000);
			})
			.catch(error => {
				let status = error.response.status;
				if(status >= 404){
					this.msgStatus = {
						msg: error.response.data.message.split(';')[0],
						valid: false
					}
				}
				else{
					this.msgStatus = {
						msg: 'Error sending message, try another platform',
						valid: false
					}
				}
				setTimeout(() => { this.msgStatus.valid = null; }, 3000);
			});
		},
		clearMsg: function(){
			this.fromEmail = 'Email';
			this.fromName = 'Name';
			this.body = 'Message';
			this.msgStatus = {
				msg: null,
				valid: null
			};
		}
	}
}
</script>

<style scoped lang="scss">
	@import "~@/assets/scss/_variables.scss";

	.slide-enter-active, .slide-leave-active {
		transition:height 0.5s ease-out;
    	height:auto;
    	opacity: 1;
	}
	.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
		opacity: 0;
	}

	#contact{
		background: $darkPurple;
		height: 90vh;
		width: 100vw;
		display: grid;
		grid-template-columns: 33.33% 66.66%;

		.pageTitle{
			text-align: center;
			margin: auto;

			.title{
				writing-mode: vertical-rl;
				text-orientation: upright;
				font-family: 'Montserrat', sans-serif;
				font-weight: bold;
				font-size: 3em;
				color: $nearWhite;
				text-shadow: -10px 20px 20px #0000006e;
			}
		}

		.contactBox{
			width: 75%;
			margin: auto;
			background: transparent;

			.contactForm{
				display: grid;
				grid-template-rows: 10% 90%;
				*{
					width: 100%;
					border: none;	
				}

				.msgStatus{
					text-align: center;
					font-family: 'Montserrat', sans-serif;
					color: white;
					transition: all .2s ease-in-out;

					h1{
						transform: translateY(50%);
					}

					&.success{
						background: rgba(0,128,0,.5);
					}
					&.error{
						background: #ff0000a3;
					}
				}

				.inputShadow{
					box-shadow: 20px 10px 30px 20px #0000006e;
				}

				input{ 
					height: 10%; 
					padding: 10px; 
					background: white;
					font-family: 'Montserrat';
					border-bottom: 1px solid $darkPurple;
				}

				textarea{ 
					height: 15em; 
					padding: 10px; 
					font-family: 'Montserrat';
				}

				.formButtons{
					display: inline-flex;
					background: transparent;
					padding: 0.5em;
					margin: 1em 0;

					button{
						width: 25%;
						margin: auto;
						background: $beigeMint;
						border-radius: 50px;
						color: white;
						text-transform: uppercase;
						transition: all .2s ease-in-out;

						&:hover{
							transform: scale(1.2);
							font-weight: bold;
						}
					}
				}
			}

			.socialIcons{
				width: 100%;
				display: grid;
				grid-template-columns: 25% 25% 25% 25%;
				
				a {
					height: 4em;
    				width: 4em;
    				margin: auto;
    				transition: all .2s ease-in-out;
					border-radius: 50%;
					color: $nearWhite;
					text-align: center;

					i{
						transform: translateY(50%);
						margin: auto;
						width: 100%;
					}

					&:hover{
						background: $beigeMint;
						color: white;
						border-color: $beigeMint;
					}
				}
			}
		}
	}
	@media screen and (max-width: $tabletWidth){
		#contact{
			grid-template-columns: 100%;
			grid-template-rows: 25% 75%;

			.pageTitle{
				.title{
					writing-mode: initial;
					text-orientation: initial;
				}
			}
		}
	}
	@media screen and (max-width: $largeMobile){
		#contact{
			grid-template-rows: 10% 90%;
			
			.pageTitle{
				.title{
					font-size: 2em;
				}
			}

			.contactBox{
				.contactForm{
					.msgStatus{
						font-size: 14px;						
					}
				}

				.socialIcons{
					margin: 2em 0;
				}
			}
		}
	}
</style>